<template>
    <validation-observer ref="validationObserver" v-slot="{ handleSubmit }">
        <b-modal v-model="modalAberto" :title="title" header-bg-variant="secondary" header-text-variant="light"
            @hide="closeModal" centered>
            <b-form @submit.prevent="handleSubmit(homologar)">
                <b-container>
                    <b-row>
                        <b-col cols="12">
                            <default-form-validation-provider label="Data de homologação:">
                                <b-form-datepicker v-model="dataHomologacao" locale="pt-BR"
                                    placeholder="Escolha uma data" class="mb-2" :max="hoje"></b-form-datepicker>
                            </default-form-validation-provider>
                        </b-col>
                        <b-col cols="12">
                            <default-form-validation-provider label="Ato de homologação:">
                                <b-form-file placeholder="Nenhum arquivo selecionado" v-model="anexoAtoHomo"
                                    accept=".pdf"></b-form-file>
                            </default-form-validation-provider>
                        </b-col>
                        <b-col cols="12">
                            <default-form-validation-provider label="Resultado final:">
                                <b-form-file placeholder="Nenhum arquivo selecionado" v-model="anexoResultFinal"
                                    accept=".pdf"></b-form-file>
                            </default-form-validation-provider>
                        </b-col>
                    </b-row>
                </b-container>
            </b-form>
            <template #modal-footer>
                <b-button size="sm" variant="outline-secondary" @click="closeModal">Cancelar</b-button>
                <b-button size="sm" variant="secondary" type="submit" @click="handleSubmit(homologar)"
                    :disabled="!dataHomologacao || !anexoAtoHomo || !anexoResultFinal">
                    Homologar
                </b-button>
            </template>
        </b-modal>
    </validation-observer>
</template>

<script lang="ts">
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { ValidationObserver } from "vee-validate";
import { Component, Vue, Prop } from "vue-property-decorator";
import concursoService from "@/services/atos-pessoal/concursoService";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";

@Component({
    components: {
        ValidationObserver,
        DefaultFormValidationProvider
    },
})
export default class ModalHomologar extends mixins(UtilsTS, Vue) {
    @Prop({ required: true }) edital!: any;
    @Prop({ required: true }) title!: string;

    modalAberto = true
    dataHomologacao: any = null;
    anexoAtoHomo: File | null = null;
    anexoResultFinal: File | null = null;
    hoje = new Date().toISOString().split("T")[0];

    async homologar() {
        try {
            const payload = {
                IdEdital: this.edital.IdEdital,
                DataHomologacao: this.dataHomologacao,
                AtoHomologacao: this.anexoAtoHomo,
                ResultadoFinal: this.anexoResultFinal,
            };
            //const response = await concursoService.homologarConcurso(payload)
            //if (response) this.$toast.success("Concurso homologado com sucesso!")
            this.closeModal()
        } catch (error: any) {
            this.tratarError(error)
            console.error("Erro ao homologar", error);
        } finally {
            this.$emit("reload")
        }
    }

    closeModal() {
        this.$emit("close");
    }
}
</script>